export default __webpack_public_path__ + "static/media/qcc_earnings_notifications.ee6be30a.svg";